import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import filtersSelectors from '@/finsight/application/actions/bonds/filters/selectors';
import { IParamsInitial, useFiltersContext } from '@/finsight/application/FiltersContext';
import { useBondsAssetClassesContext } from '@/finsight/application/Bonds/BondsAssetClassesContext';

const stateSelector = (state) => ({
  filter: filtersSelectors.getFiltersPayload(state),
});

const useGetBondsPayload = () => {
  const { filter } = useSelector(stateSelector);
  const { params } = useFiltersContext();
  const { currentAssetClass } = useBondsAssetClassesContext();

  const getPayload = useCallback((
      { assetClassId, params: propsParams }: { assetClassId?: string, params?: IParamsInitial },
  ) => (
      {
        ...params,
        ...propsParams,
        search: propsParams?.search !== undefined ? propsParams.search : params.search,
        filter: {
          ...filter,
          includedAssetClassId: assetClassId || currentAssetClass?.id,
        },
      }
  ), [params, filter, currentAssetClass]);

  return { getPayload };
};

export default useGetBondsPayload;
